var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.vueAppClasses,attrs:{"id":"app"},on:{"mouseup":_vm.mouseUp,"dblclick":_vm.dblClick}},[_c('Template')],1)}
var staticRenderFns = []

export { render, staticRenderFns }